import { useEffect } from 'react';
import { useAnalyticsAvailability } from 'contexts/AnalyticsAvailabilityContext';
import logger from 'services/logger';
import { trackPage } from 'services/yleAnalyticsSdk';

// As of start of 2026 this tracks page views only for Audience Project
export function useAnalyticsForView(): void {
  const { isAvailable: isAnalyticsAvailable } = useAnalyticsAvailability();

  useEffect(() => {
    if (isAnalyticsAvailable) {
      try {
        trackPage();
      } catch (e) {
        logger.error(e);
      }
    }
  }, [isAnalyticsAvailable]);
}
